import { TagProps } from "@bluframe/blublocks"

import Tag from "./Tag"

export interface Props extends TagProps {}

export interface ComponentProps extends Props {}

export default Tag
